import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Main from './containers/MainPage';
import { ThemeContextProvider } from './context/ThemeContext';

function App() {
  const isDashboardAllowed = localStorage.getItem("userRoleId") === "2";

  return (
    <ThemeContextProvider>
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/concept_creator" replace />} />
        <Route path="/concept_creator" element={<Main initialTab="Concept Creator" />} />
        <Route path="/content_creator" element={<Main initialTab="Content Creator" />} />
        <Route path="/content_creator/results" element={<Main initialTab="Content Creator" contentView="results" />} />
        <Route path="/sharepoint" element={<Main initialTab="CHIP Repository Hub" />} />
        <Route
          path="/dashboard"
          element={isDashboardAllowed ? <Main initialTab="Dashboard" /> : <Navigate to="/concept_creator" replace />}
        />
        <Route path="*" element={<Navigate to="/concept_creator" replace />} />
      </Routes>
    </Router>
    </ThemeContextProvider>
  );
}

export default App;